import "../styles/Tweet.css";

import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faComment, faHeart} from "@fortawesome/free-regular-svg-icons";
import {faArrowUpFromBracket, faRetweet} from "@fortawesome/free-solid-svg-icons";
import VerifiedBadge from "./VerifiedBadge";

const Tweet = ({ name, color, title, titleImage, verified, profilePicture, content, timestamp, location, locationFlag }) => {
    return (
        <div id="tweet-container">
            <div id="tweet-author">
                <img id="profile-picture" src={profilePicture} style={{ border: "2px solid " + color, padding: "2px" }}/>
                <div id="tweet-username">
                    <span className="major">{name}{verified ? <VerifiedBadge/> : <></>}</span>
                    <span className="minor">
                        {titleImage ? <img src={titleImage} alt=""/> : <></>}
                        <span>{title}</span>
                    </span>
                </div>
            </div>
            <div id="tweet-content">
                {content}
            </div>
            <div id="tweet-bottom">
                <span id="tweet-timestamp">{timestamp}</span>
                <span id="tweet-location">
                    {locationFlag ? <img src={locationFlag} alt=""/> : <></>}
                    <span>{location}</span>
                </span>
            </div>
            <div id="tweet-controls">
                <svg width="20" height="20" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.6226 42.469V40.3249L22.5035 39.9982C16.2462 39.0336 11.2115 36.8697 7.78521 33.8195C4.41376 30.818 2.5 26.8817 2.5 22.0095C2.5 14.355 7.92043 7.37667 16.4573 3.83784C19.6894 2.49805 22.944 2.49922 27.5107 2.50086C27.6721 2.50092 27.8352 2.50098 28 2.50098C33.1996 2.50098 37.8961 2.61409 41.4451 4.23015C49.4656 7.88242 54.5 14.6273 54.5 22.0095C54.5 26.9214 52.6904 32.3525 49.1877 36.4341C46.0228 40.1221 43.0844 42.1169 41.6119 43.1165C41.3751 43.2773 41.1762 43.4123 41.0204 43.5245C36.1131 47.0577 28.9114 50.4092 24.6226 52.2588V42.469Z" stroke-width="5"/>
                </svg>

                <svg width="36" height="20" viewBox="0 0 78 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.5 2.5V38.5C14.5 42.9183 18.0817 46.5 22.5 46.5H42M14.5 2.5L26 13.5M14.5 2.5L3 13.5M63.5 46.5V10.5C63.5 6.08172 59.9183 2.5 55.5 2.5H36M63.5 46.5L52 35.5M63.5 46.5L75 35.5" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                <svg width="20" height="20" viewBox="0 0 60 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.5 3C23.8684 3 30 11.4994 30 11.4994C30 11.4994 36.1316 3 43.5 3C48 3 53.1783 4.02116 55.5 9.49939C58.938 17.6116 57.079 26.5138 52.5 34.0411C49.4136 39.1147 47.491 41.8989 43 45.9994C40.8798 47.9352 37.9755 50.272 35.5 52.1998C32.7319 54.3553 30 54.5 30 54.5C30 54.5 27.2681 54.3553 24.5 52.1998C22.0245 50.272 19.1202 47.9352 17 45.9994C12.509 41.8989 10.5864 39.1147 7.50001 34.0411C2.92104 26.5138 1.06196 17.6116 4.49999 9.49939C6.82173 4.02116 12 3 16.5 3Z" stroke-width="5"/>
                </svg>

                <svg width="20" height="20" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 33V50C3 52.2091 4.79086 54 7 54H28.75H50.5C52.7091 54 54.5 52.2091 54.5 50V33M28.75 3L42.625 18M28.75 3L14.875 18M28.75 3V38" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    )
}

export default Tweet;
